export const HOMEPAGE_SNAP_SECTIONS = {
  CARS: "cars",
  EXPLORE_FURTHER: "explore",
};
